import React from 'react';
import {Box} from '@material-ui/core';
import {compactNumberFormatter} from '@epic-visualizations/charts';
import {PieLabelRenderProps} from 'recharts';
import {getLocale} from '@epic-core/common/dist';

import ActivationsEmphasis from './ActivationsEmphasis';
import {percentFormatter} from '../utils';
import {PERCENT_FORMAT_SINGLE_FRACTION} from '../constants';

export interface RenderEmphasisProps extends PieLabelRenderProps {
    activeIndex: number;
    total: number;
    title: string;
    description: string;
}

const renderEmphasis = ({
    cx,
    cy,
    innerRadius,
    index,
    name,
    value,
    total,
    title,
    description,
    activeIndex
}: RenderEmphasisProps) => {
    const locale = getLocale();
    const isTotalEmphasis = activeIndex === undefined && !index;

    if (index !== activeIndex && !isTotalEmphasis) {
        return null;
    }

    if (typeof cx !== 'number' || typeof cy !== 'number' || typeof innerRadius !== 'number') {
        return null;
    }

    const label: string = isTotalEmphasis ? title : name;
    const stat = isTotalEmphasis
        ? compactNumberFormatter(locale)(total)
        : percentFormatter(locale, PERCENT_FORMAT_SINGLE_FRACTION)(value);

    return (
        <foreignObject
            x={cx - innerRadius}
            y={cy - innerRadius}
            width={innerRadius * 2}
            height={innerRadius * 2}
            style={{pointerEvents: 'none'}}>
            <Box
                width={innerRadius * 2}
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center">
                <ActivationsEmphasis label={label} value={stat} description={description} />
            </Box>
        </foreignObject>
    );
};

export default renderEmphasis;
